import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FeatureGuard } from '../../extras/feature.guard';
import {AccountingTransactionsListComponent} from './pages/accounting-transactions-list/accounting-transactions-list.component';
import { AuthGuard } from '../../extras/auth.guard';

// const routes: Routes = [];
const clientroutes: Routes = [
  {
    path:'transaction',
    canActivate: [AuthGuard],   // logged-in users only
    children:[
      {
        path:'',
        // component:DashboardComponent,
        children:[
          { path:'list/:jobId', component:AccountingTransactionsListComponent, canActivate: [FeatureGuard], data: { feature: 'acct.ledger' } },

        ]
      }
    ]
  }
];
@NgModule({
  imports: [RouterModule.forChild(clientroutes)],
  exports: [RouterModule]
})
export class TransactionsRoutingModule { }
